import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import $type from '@tandem/ui/type.css'
import $table from '@tandem/ui/table.css'
import Spinner from '@tandem/ui/Spinner'

import { useTRPC } from '@/trpc'

export const Route = createFileRoute('/proexpert/')({
  component: ProexpertPage,
})

function ProexpertPage() {
  let trpc = useTRPC()
  let queryClient = useQueryClient()
  let { data: experts = [], isFetching } = useQuery(trpc.proexpert.expert.list.queryOptions())

  let [name, setName] = useState('')
  let [specialization, setSpecialization] = useState('')

  let creation = useMutation(trpc.proexpert.expert.create.mutationOptions({
    onSuccess() {
      setName('')
      setSpecialization('')
      queryClient.invalidateQueries(trpc.proexpert.expert.list.queryOptions())
    }
  }))

  return (
    <div>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          if (name.trim()) creation.mutate({ name, specialization: specialization || undefined })
        }}
      >
        <input value={name} placeholder='Имя' onChange={(e) => setName(e.target.value)} />
        <input value={specialization} placeholder='Специализация' onChange={(e) => setSpecialization(e.target.value)} />
        <button type='submit' disabled={creation.isPending}>Добавить</button>
      </form>

      {experts.length > 0 ?
        <table class={$table.table}>
          <thead>
            <tr>
              <th>Имя</th>
              <th>Специализация</th>
            </tr>
          </thead>
          <tbody>
            {experts.map((expert) => (
              <tr key={expert.id}>
                <td>{expert.name}</td>
                <td>{expert.specialization ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      : <p class={$type.muted}>{isFetching ? <Spinner /> : 'Нет экспертов.'}</p>
      }
    </div>
  )
}
